/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions
 */
export interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions
     */
    IpAddress: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(value: object): value is FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions {
    if (!('IpAddress' in value) || value['IpAddress'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'IpAddress': json['IpAddress'],
    };
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'IpAddress': value['IpAddress'],
    };
}

